import { useRef, useState, useEffect } from "react"
import Header from "../../../layouts/Header"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import { Box, Button } from "@mui/material"
import dayjs from "dayjs"
import BackIcon from "../../../components/BackIcon"
import CustomTextField from "../../../components/CustomTextField"
import CustomAutocomplete from "../../../components/CustomAutocomplete"
import CustomDatePicker from "../../../components/CustomDatePicker"
import CustomFieldsetAccordion from "../../../components/CustomFieldsetAccordion"
import CustomHelperDetail from "../../../components/CustomHelperDetail"
import CustomTooltip from "../../../components/ToolTip"
import EjecutarIcon from "../../../assets/iconos/EjecutarAccion.ico"
import CustomConditionalActionsTableServer from "../../../components/CustomConditionalActionsTableServerSide"
import normalFormatDate from "../../utils/date/DDMMYYYFormatDate"
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye"
import { useNavigate } from "react-router-dom"

const StyledRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(8),
  flexGrow: 1,
  padding: "0 16px",
  height: "100vh",
}))

const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87", // Cambia el color secundario a verde azulado
    },
  },
})

const ContainerFiltros = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(12, 1fr)",
  gridTemplateRows: "auto auto auto",
  gridTemplateAreas: `
          "IOrdenCompra IOrdenCompra IOrdenCompra IOrdenCompra IOrdenCompra IOrdenCompra IImportacion IImportacion IImportacion IImportacion IImportacion IImportacion"
          "IFechaInicial IFechaInicial IFechaInicial IFechaInicial IFechaInicial IFechaInicial IFechaFinal IFechaFinal IFechaFinal IFechaFinal IFechaFinal IFechaFinal"
          "IEstado IEstado IEstado IEstado IEstado IEstado IEstado IEstado IEstado IEstado IEstado IEstado"
          "IProveedor IProveedor IProveedor IProveedor IProveedor IProveedor IProveedor IProveedor IProveedor IProveedor IProveedor IProveedor"
          "ITipoOrden ITipoOrden ITipoOrden ITipoOrden ITipoOrden ITipoOrden ITipoOrden ITipoOrden ITipoOrden ITipoOrden ITipoOrden ITipoOrden"
        `,
  gap: "8px",
  alignItems: "center",
  // Versión para pantallas pequeñas
  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "1fr",
    gridTemplateRows: "auto auto auto auto auto auto",
    gridTemplateAreas: `
      "IOrdenCompra"
      "IImportacion"
      "IFechaInicial"
      "IFechaFinal"
      "IEstado"
      "IProveedor"
      "ITipoOrden"
    `,
    gap: "12px",
  },
}))

const IOrdenCompra = styled(Box)({
  gridArea: "IOrdenCompra",
})
const IImportacion = styled(Box)({
  gridArea: "IImportacion",
})
const IFechaInicial = styled(Box)({
  gridArea: "IFechaInicial",
})
const IFechaFinal = styled(Box)({
  gridArea: "IFechaFinal",
})
const IEstado = styled(Box)({
  gridArea: "IEstado",
})
const IProveedor = styled(Box)({
  gridArea: "IProveedor",
})
const ITipoOrden = styled(Box)({
  gridArea: "ITipoOrden",
})

const OCGerenciaAdquisicionesCrear = () => {
  const navigate = useNavigate()
  const [datosFiltros, setDatosFiltros] = useState({
    ordenCompra: "",
    importacion: "",
    fechaInicial: null,
    fechaFinal: null,
    estado: {
      label: "(P) Pendiente",
      value: "P",
    }, // Manaje el estado del autocomplete
    proveeddor: "",
    tipoOrden: null, // Manaje el estado del autocomplete
  })
  const handleSetDatosFiltros = (k, v) => setDatosFiltros((prev) => ({ ...prev, [k]: v }))
  const [expandedFiltros, setExpandedFiltros] = useState(false)
  const handleToggleFiltros = () => {
    setExpandedFiltros(!expandedFiltros)
  }
  const [refreshCustomReadableTableServerKey, setRefreshCustomReadableTableServerKey] = useState(1) // <-- Controla el reinicio del custom readable table server cada vez que se de click en filtrar
  const CustomConditionalActionsTableServerRef = useRef(null) // Controla el scroll al bottom de la pagina cuando se de click en filtrar

  const scrollToBottom = () => {
    CustomConditionalActionsTableServerRef.current?.scrollIntoView({ behavior: "smooth" })
  }

  const handleSearching = () => {
    setRefreshCustomReadableTableServerKey((prev) => prev + 1)
    setExpandedFiltros(false)
  }
  // Efecto para hacer scroll cuando termina la carga
  useEffect(() => {
    if (CustomConditionalActionsTableServerRef.current) {
      CustomConditionalActionsTableServerRef.current.scrollIntoView({
        behavior: "smooth",
        block: "end",
      })
    }
  }, [refreshCustomReadableTableServerKey])
  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />
        <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
          <div style={{ paddingTop: "10px", paddingBottom: "10px" }}>
            <CustomTooltip title={"Buscar"}>
              <Button style={{ fontSize: "0.9vw" }} onClick={handleSearching}>
                <img src={EjecutarIcon} alt="Crear" style={{ width: "40px" }} />
              </Button>
            </CustomTooltip>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        >
          <b style={{ textAlign: "center" }}>Aprobación de Orden de Compra Gerencia Adquisiciones</b>
        </div>

        <Box className={StyledRoot}>
          <CustomFieldsetAccordion title="Búsqueda" expanded={expandedFiltros} onToggle={handleToggleFiltros}>
            <ContainerFiltros>
              <IOrdenCompra>
                <CustomTextField
                  label="Orden Compra"
                  value={datosFiltros.ordenCompra}
                  setValue={(v) => handleSetDatosFiltros("ordenCompra", v)}
                />
              </IOrdenCompra>
              <IImportacion>
                <CustomTextField
                  label="Importación"
                  value={datosFiltros.importacion}
                  setValue={(v) => handleSetDatosFiltros("importacion", v)}
                />
              </IImportacion>
              <IFechaInicial>
                <CustomDatePicker
                  label="Fecha Emisión Inicial"
                  value={datosFiltros.fechaInicial}
                  setValue={(v) => handleSetDatosFiltros("fechaInicial", v)}
                  isOptional={true}
                  defaultValue={dayjs(new Date())}
                  checkboxInitialChecked={false}
                />
              </IFechaInicial>
              <IFechaFinal>
                <CustomDatePicker
                  label="Fecha Emisión Final"
                  value={datosFiltros.fechaFinal}
                  setValue={(v) => handleSetDatosFiltros("fechaFinal", v)}
                  isOptional={true}
                  defaultValue={dayjs(new Date())}
                  checkboxInitialChecked={false}
                />
              </IFechaFinal>
              <IEstado>
                <CustomAutocomplete
                  label="Estado"
                  selectedOption={datosFiltros.estado}
                  setSelectedOption={(v) => {
                    setDatosFiltros((prev) => ({
                      ...prev,
                      estado: v,
                      // vencodigo: v?.vencodigo ?? null,
                    }))
                  }}
                  options={[
                    {
                      label: "(P) Pendiente",
                      value: "P",
                    },
                    {
                      label: "(D) REVISAR ORDEN",
                      value: "D",
                    },
                    {
                      label: "(A) APROBADA",
                      value: "A",
                    },
                  ]}
                />
              </IEstado>

              <IProveedor>
                <CustomHelperDetail
                  label="Proveedor"
                  valueSearched={datosFiltros.proveedor?.procodigo}
                  endpoint="/OCGerenciaAdquisiciones/getProveedoresHelper"
                  valueInputMain="procodigo"
                  valueInputSecondary="pronombre"
                  idSearchField="procodigo"
                  errorMsgIdSearch="Error fetching data:"
                  errorMsgFilterSearch="Error en cargar datos"
                  queryKeyModal="proveedoresGerenciaAdquisiciones"
                  perPage={10}
                  placeholder=""
                  columnsTable={[
                    {
                      accessorKey: "procodigo",
                      header: "Código",
                      size: 100,
                      Cell: ({ cell }) => {
                        const value = cell.getValue()
                        return <span>{value}</span>
                      },
                    },
                    {
                      accessorKey: "pronombre",
                      header: "Nombre del Proveedor",
                      size: 300,
                      Cell: ({ cell }) => {
                        const value = cell.getValue()
                        return <span>{value}</span>
                      },
                    },
                    {
                      accessorKey: "proruc",
                      header: "RUC",
                      size: 200,
                      Cell: ({ cell }) => {
                        const value = cell.getValue()
                        return <span>{value}</span>
                      },
                    },
                    {
                      accessorKey: "protelef1",
                      header: "Teléfono",
                      size: 200,
                      Cell: ({ cell }) => {
                        const value = cell.getValue()
                        return <span>{value}</span>
                      },
                    },
                    {
                      accessorKey: "prostatusSTR",
                      header: "Estado",
                      size: 100,
                      Cell: ({ cell }) => {
                        const value = cell.getValue()
                        return <span>{value}</span>
                      },
                    },
                  ]}
                  onHandleSelectedData={(v) => handleSetDatosFiltros("proveedor", v)}
                  sxInputMain={{
                    minWidth: "170px",
                    maxWidth: "170px",
                    marginRight: "10px",
                  }}
                  sxInputSecondary={{
                    width: "100%",
                  }}
                />
              </IProveedor>
              <ITipoOrden>
                <CustomAutocomplete
                  label="Tipo de Orden"
                  selectedOption={datosFiltros.tipoOrden}
                  setSelectedOption={(v) => {
                    setDatosFiltros((prev) => ({
                      ...prev,
                      tipoOrden: v,
                      // vencodigo: v?.vencodigo ?? null,
                    }))
                  }}
                  options={[
                    {
                      label: "COMPRA LOCAL MERCADERIAS   (CL)",
                      value: "CL",
                    },
                    {
                      label: "COMPRA PROPIEDADES, PLANTA Y EQUIPO   (CAF)",
                      value: "CAF",
                    },
                    {
                      label: "O/C LIQUIDACION COMPRAS BYS   (OBS)",
                      value: "OBS",
                    },
                    {
                      label: "ORDEN COMPRA BIENES GASTOS   (CBS)",
                      value: "CBS",
                    },
                    {
                      label: "ORDEN COMPRA SERVICIOS   (CSG)",
                      value: "CSG",
                    },
                    {
                      label: "ORDEN SERVICIOS BASICOS   (CSB)",
                      value: "CSB",
                    },
                  ]}
                />
              </ITipoOrden>
            </ContainerFiltros>
          </CustomFieldsetAccordion>

          <br />
          <br />

          <div ref={CustomConditionalActionsTableServerRef}>
            {refreshCustomReadableTableServerKey !== 0 && (
              <CustomConditionalActionsTableServer
                key={refreshCustomReadableTableServerKey}
                endpoint="/OCGerenciaAdquisiciones/getFilteredOrdenCompra"
                endpointJson={{
                  externalFilters: {
                    ordenCompra: datosFiltros.ordenCompra,
                    importacion: datosFiltros.importacion,
                    rangoFechaEmision: [
                      datosFiltros.fechaInicial?.format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") ?? null,
                      datosFiltros.fechaFinal?.format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") ?? null,
                    ],
                    estado: datosFiltros?.estado?.value ?? null,
                    proveeddor: datosFiltros.proveedor?.procodigo ?? null,
                    tipoOrden: datosFiltros?.tipoOrden?.value ?? null,
                  },
                }}
                errorMsgFilterSearch="Error en cargar datos"
                queryKeyModal="OrdenesCompraFiltradasOCGerenciaAdquisiciones"
                perPage={10}
                rowActionsWidthTable={140}
                rowActions={(row) => {
                  const actions = [
                    {
                      label: "Ver",
                      key: "VerAction",
                      icon: <RemoveRedEyeIcon sx={{ color: "#14AFF7" }} />,
                      onClick: (row) => {
                        navigate(`ordenCompra`, { state: row.original })
                      },
                    },
                  ]

                  return actions
                }}
                columnsTable={[
                  {
                    accessorKey: "ciacodigo",
                    header: "Código Compañía",
                    size: 150,
                    Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                  },
                  {
                    accessorKey: "cocid",
                    header: "Orden de Compra",
                    size: 150,
                    Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                  },
                  {
                    accessorKey: "pronombre",
                    header: "Proveedor",
                    size: 200,
                    Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                  },
                  {
                    accessorKey: "cocfecemi",
                    header: "Fecha de Emisión",
                    size: 180,
                    Cell: ({ cell }) => <span>{normalFormatDate(cell.getValue())}</span>,
                  },
                  {
                    accessorKey: "cocfecposent",
                    header: "Fecha de Entrega",
                    size: 180,
                    Cell: ({ cell }) => <span>{normalFormatDate(cell.getValue())}</span>,
                  },
                  {
                    accessorKey: "cocfectransito",
                    header: "Fecha de Tránsito",
                    size: 180,
                    Cell: ({ cell }) => {
                      const fecha = cell.getValue()
                      return <span>{fecha ? normalFormatDate(fecha) : ""}</span>
                    },
                  },
                  {
                    accessorKey: "cocfecarribo",
                    header: "Fecha de Arribo",
                    size: 180,
                    Cell: ({ cell }) => {
                      const fecha = cell.getValue()
                      return <span>{fecha ? normalFormatDate(fecha) : ""}</span>
                    },
                  },

                  {
                    accessorKey: "cocvalorreal",
                    header: "Valor Real",
                    size: 150,
                    Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                  },
                  {
                    accessorKey: "cocdescri",
                    header: "Descripción",
                    size: 250,
                    Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                  },
                  {
                    accessorKey: "cocstatus",
                    header: "Estado de Orden de Compra",
                    size: 200,
                    Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                  },
                  {
                    accessorKey: "staimportacion",
                    header: "Estado Importación",
                    size: 180,
                    Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                  },
                  {
                    accessorKey: "stainventarios",
                    header: "Estado Inventarios",
                    size: 180,
                    Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                  },
                ]}
              />
            )}
          </div>
        </Box>
      </div>
    </ThemeProvider>
  )
}

export default OCGerenciaAdquisicionesCrear
